var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSendFillRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.57704 11.6362C0.901061 11.9602 1.40959 11.9107 2.00813 11.6452L12.6558 6.8929C12.9438 6.76689 13.1733 6.62738 13.3263 6.47437C13.6189 6.18186 13.6189 5.82183 13.3263 5.52932C13.1733 5.37631 12.9438 5.2368 12.6558 5.11079L1.94963 0.33599C1.42759 0.101975 0.905561 0.0389708 0.57704 0.367491C0.163014 0.781517 0.338525 1.23605 0.640044 1.79858L2.33215 4.96678C2.53016 5.3448 2.69667 5.49331 3.0747 5.51131L12.6198 5.83083C12.7323 5.83533 12.7908 5.91184 12.7998 6.00184C12.7998 6.09185 12.7368 6.16386 12.6243 6.16836L3.0702 6.52388C2.71467 6.53738 2.54816 6.67689 2.33215 7.06391L0.671546 10.1556C0.352026 10.7451 0.158514 11.2177 0.57704 11.6362Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendFillRight);
export default __webpack_public_path__ + "static/media/icon-send-fill-right.df30635eece1cbd8d035aed579f9623a.svg";
export { ForwardRef as ReactComponent };